// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2764":"c610c637","5635":"4529ed17"}[chunkId] + ".chunk.css");